
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/TranslationProvider';

const MyBackButton = () => {
    const navigate = useNavigate();
    const { t } = useLang();
  return (
    <div className="mb-4">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-gray-200 dark:text-gray-700 hover:bg-gray-300 rounded-lg"
        >
          {t("Back")}
        </button>
      </div>
  )
}

export default MyBackButton
